import React, { useState, useEffect, createContext } from 'react';
import axios from 'axios';
import CockpitPage from './CockpitPage';

const API = axios.create({ baseURL: '/api', timeout: 30000 });

export const AuthContext = createContext({});

function LoginPage({ onLogin }) {
  const [email,   setEmail]   = useState('');
  const [pw,      setPw]      = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const r = await API.post('/cockpit/auth/login', { username: email, password: pw });
      onLogin({ ...r.data, access_token: r.data.access_token });
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Anmeldung fehlgeschlagen.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">
          <img src="/sirius-logo.png" alt="SIRIUS Ventures" style={{ height: 40, width: 'auto', objectFit: 'contain' }} />
          <div>
            <div className="login-logo-text">SIRIUS Dev Dashboard</div>
            <span className="login-logo-sub">Multi-Projekt Management · dev-dash.sirius-europe.com</span>
          </div>
        </div>
        <div className="login-title">Anmelden</div>
        <div className="login-sub">Bitte melden Sie sich mit Ihren SIRIUS-Zugangsdaten an.</div>
        {error && <div className="login-error">⚠ {error}</div>}
        <div className="login-field">
          <label className="login-label">E-Mail-Adresse</label>
          <input className="login-input" type="email" inputMode="email" autoComplete="email" value={email}
            onChange={e => setEmail(e.target.value)} placeholder="name@sirius-europe.com" autoFocus required />
        </div>
        <div className="login-field">
          <label className="login-label">Passwort</label>
          <input className="login-input" type="password" autoComplete="current-password" value={pw}
            onChange={e => setPw(e.target.value)} placeholder="••••••••••" required />
        </div>
        <button className="login-btn" type="submit" disabled={loading}>
          {loading ? 'Anmelden…' : 'Anmelden'}
        </button>
        <div style={{ textAlign: 'center', marginTop: 8 }}>
          <button
            type="button"
            onClick={() => { localStorage.clear(); window.location.reload(); }}
            style={{ background: 'none', border: 'none', color: 'var(--text3, #666)',
              fontSize: 11, cursor: 'pointer', textDecoration: 'underline' }}>
            Sitzung zurücksetzen (bei Login-Problemen)
          </button>
        </div>
        <div className="login-footer">
          SIRIUS Dev Dashboard · v1.0<br />
          <span style={{ opacity: 0.5 }}>Vertraulich — Nur für autorisierte Nutzer</span>
          <div className="login-footer-brand">
            <img src="/sirius-logo.png" alt="SIRIUS Ventures" style={{ height: 20, width: 'auto', objectFit: 'contain' }} />
            SIRIUS Ventures
          </div>
        </div>
      </form>
    </div>
  );
}

function Topbar({ user, onLogout }) {
  const initials = user?.user_name?.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'U';
  return (
    <div style={{
      flexShrink: 0,
      background: 'var(--topbar-bg)', borderBottom: '1px solid var(--border)',
      paddingTop: 'env(safe-area-inset-top)',
    }}>
    <style>{`
      @media (max-width: 767px) {
        .topbar-username { display: none !important; }
        .topbar-domain { display: none !important; }
        .topbar-logout-text { display: none !important; }
        .topbar-logout-icon { display: flex !important; }
        .topbar-title-full { display: none !important; }
        .topbar-title-short { display: inline !important; }
        .topbar-bar { height: 44px !important; padding: 0 12px !important; }
        .topbar-logo { height: 22px !important; }
      }
      @media (max-width: 479px) {
        .topbar-logo { display: none !important; }
        .topbar-bar { height: 40px !important; padding: 0 10px !important; }
      }
      @media (min-width: 768px) {
        .topbar-logout-icon { display: none !important; }
        .topbar-title-short { display: none !important; }
      }
    `}</style>
    <div className="topbar-bar" style={{
      height: 52,
      display: 'flex', alignItems: 'center', padding: '0 20px', gap: 14,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <img src="/sirius-logo.png" alt="SIRIUS Ventures" className="topbar-logo" style={{ height: 28, width: 'auto', objectFit: 'contain' }} />
        <span className="topbar-title-full" style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', letterSpacing: -0.3 }}>
          SIRIUS Dev Dashboard
        </span>
        <span className="topbar-title-short" style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', letterSpacing: -0.3 }}>
          dev-dash
        </span>
        <span className="topbar-domain" style={{ fontSize: 10.5, color: 'var(--text3)', fontFamily: 'var(--mono)' }}>
          dev-dash.sirius-europe.com
        </span>
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 32, height: 32, background: 'var(--bg3)', borderRadius: '50%',
          border: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 11, fontWeight: 700, color: 'var(--text2)', flexShrink: 0,
        }}>{initials}</div>
        <span className="topbar-username" style={{ fontSize: 12, color: 'var(--text2)' }}>{user?.user_name || user?.user_email || 'User'}</span>
        <button onClick={onLogout} style={{
          background: 'none', border: '1px solid var(--border)', color: 'var(--text3)',
          fontSize: 11.5, padding: '4px 10px', borderRadius: 5, cursor: 'pointer',
          fontFamily: 'var(--font)',
        }} className="topbar-logout-text">Abmelden</button>
        <button onClick={onLogout} className="topbar-logout-icon" title="Abmelden" style={{
          background: 'none', border: '1px solid var(--border)', color: 'var(--text3)',
          width: 44, height: 44, borderRadius: 8, cursor: 'pointer',
          alignItems: 'center', justifyContent: 'center', padding: 0, display: 'none',
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    </div>
    </div>
  );
}

export default function App() {
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem('devdash_auth') || 'null'); } catch { return null; }
  });

  const handleLogin = (data) => {
    localStorage.setItem('devdash_auth', JSON.stringify(data));
    setAuth(data);
  };
  const handleLogout = () => {
    localStorage.removeItem('devdash_auth');
    setAuth(null);
    if ('clearAppBadge' in navigator) navigator.clearAppBadge().catch(() => {});
  };

  useEffect(() => {
    if (auth?.access_token) {
      API.defaults.headers.common['Authorization'] = `Bearer ${auth.access_token}`;
    } else {
      delete API.defaults.headers.common['Authorization'];
    }
  }, [auth]);

  useEffect(() => {
    const handler = () => handleLogout();
    window.addEventListener('auth:expired', handler);
    return () => window.removeEventListener('auth:expired', handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!auth) return <LoginPage onLogin={handleLogin} />;

  return (
    <AuthContext.Provider value={{ auth, logout: handleLogout }}>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        <Topbar user={auth} onLogout={handleLogout} />
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <CockpitPage />
        </div>
        <div className="app-footer">
          <img src="/sirius-logo.png" alt="SIRIUS Ventures" style={{ height: 18, width: 'auto', objectFit: 'contain' }} />
          SIRIUS Ventures
        </div>
      </div>
    </AuthContext.Provider>
  );
}
